export const SERVICE = 'CAMPAIGNS'
